import {inject, injectable} from "inversify";
import {action} from "mobx";
import {STORAGE_TOKEN_NAME} from "@intelingu/core/constants/base.constants";
import {UserApi} from "@intelingu/core/api/UserApi";
import {ILocalStorageAdapter, LocalStorageSymbol} from "@intelingu/core/stores/adapters/ILocalStorageAdapter";
import {UserStore} from "@intelingu/core/stores/UserStore";
import {BootstrapStore} from "./BootstrapStore";

@injectable()
export class AuthStore {

    constructor(
        private userApi: UserApi,
        private userStore: UserStore,
        private bootstrapStore: BootstrapStore,
        @inject(LocalStorageSymbol) private localStorageAdapter: ILocalStorageAdapter,
    ) {
    }

    @action.bound async authorize(username, password) {
        const response = await this.userApi.authorize(username, password);

        const { token } = response.data;

        return this.authorizeWithToken(token);
    }

    @action.bound async authorizeWithToken(token) {
        await this.localStorageAdapter.write(STORAGE_TOKEN_NAME, token);
        await this.userStore.setToken(token);

        return this.bootstrapStore.bootstrap();
    }

}